import React from "react";
import { useEffect } from "react";
import { Box, Button, Container, Grid, Stack, Typography } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { DataGrid, GridArrowUpwardIcon } from "@mui/x-data-grid";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import { useDispatch } from "react-redux";
import CurrentForecastTracker from "./CurrentForecastTracker";
import PastForeCastTracker from "./PastForeCastTracker";
import TopSection from "../../../Components/Common/Top/TopSection";
import { setActiveDataElement } from "../../../redux/userSlice";

const Dashboard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Bottler Concentrate Forecast"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
             labelList={[
                { title: "Home", path: "/dashboard" },
                { title: "Dashboard" },
              ]}
              title = "Bottler Concentrate Forecast Upload Dashboard"
            /> 

            <div class="container">
            {/* Current Forecast Tracker */}
            <CurrentForecastTracker></CurrentForecastTracker>
            {/* Past Forecast */}
            <PastForeCastTracker></PastForeCastTracker>
             </div>

          </Grid>
        </Grid>
        </Stack>
    </>
  );
};

export default Dashboard;
